export enum ViewTypeEnum {
  List = 1,
  Kanban = 2,
  Calendar = 3,
}

export enum CalendarViewTypeSubSelectionEnum {
  Monthly = 1,
  Weekly = 2,
  Daily = 3,
}
